import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByOrder } from "../helpers";
import api from "../providers/api";

const initialState = { strategies: [], isLoading: true };

export const getThemes = createAsyncThunk("get-themes", async () => {
  const response = await api.strategy.getAllWithThemes();

  response.Data.map((item) => {
    return { ...item, Themes: sortByOrder(item.Themes) };
  });

  return response?.Data;
});

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    updateTheme: (state, action) => {
      if (state.strategies?.length === 0) return;
      const strategyIndex = state.strategies.findIndex(
        (theme) => theme.ID === action.payload?.Strategy?.ID
      );

      const itemIndex = state.strategies?.[strategyIndex].Themes.findIndex(
        (theme) => theme.ID === action.payload?.ID
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Themes[itemIndex] = action.payload;
      } else {
        state.strategies[strategyIndex].Themes.push(action.payload);
      }

      state.strategies.map((item) => {
        return {
          ...item,
          Themes: sortByOrder(item.Themes),
        };
      });
    },
    deleteTheme: (state, { payload: { strategyIndex, id } }) => {
      const itemIndex = state.strategies[strategyIndex].Themes.findIndex(
        (theme) => theme.ID === id
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Themes.splice(itemIndex, 1);
      }
    },
  },
  extraReducers: {
    [getThemes.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getThemes.pending]: (state) => {
      state.isLoading = true;
    },
    [getThemes.rejected]: (state) => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    },
  },
});

export const { updateTheme, deleteTheme } = themeSlice.actions;

export default themeSlice.reducer;
